import { render, staticRenderFns } from "./index.vue?vue&type=template&id=037a8178&scoped=true&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&id=037a8178&prod&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=037a8178&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037a8178",
  null
  
)

export default component.exports